var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#E62058",
    d: "M15.772 11.143H9.574c-1.701 0-3.098 1.29-3.141 2.923c0 .043.034.077.086.077h6.201c1.702.009 3.099-1.29 3.142-2.923a.086.086 0 0 0-.086-.077zm3-4.714h-9.24a3.047 3.047 0 0 0-3.103 2.923c0 .042.034.077.077.077h9.244a3.05 3.05 0 0 0 3.107-2.923c0-.043-.038-.077-.081-.077zM7.929 18.857a1.5 1.5 0 1 0 0-3a1.5 1.5 0 0 0 0 3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlr);
export default __webpack_public_path__ + "static/media/flr.7ed01a56982af06464ec7a947a941a8e.svg";
export { ForwardRef as ReactComponent };